// Route Change Actions
export const TOGGLE_ROUTE_SLIDING = 'TOGGLE_ROUTE_SLIDING';

// Navigation 
export const TOGGLE_NAV = 'TOGGLE_NAV';

// UI Actions
export const PRELOAD_IMAGES         = 'PRELOAD_IMAGES';

// Contact Actions
export const SEND_MESSAGE         = 'SEND_MESSAGE';
export const SEND_MESSAGE_INIT    = 'SEND_MESSAGE_INIT';
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_FAIL    = 'SEND_MESSAGE_FAIL';